const SPACING_XXS = '4px' as const;
const SPACING_XS = '8px' as const;
const SPACING_SM = '12px' as const;
const SPACING_MD = '20px' as const;
const SPACING_LG = '40px' as const;
const SPACING_XL = '80px' as const;
const SPACING_XXL = '120px' as const;
/**
 * Used occasionally on smaller screen sizes
 */
const SPACING_4 = '4px' as const;
const SPACING_8 = '8px' as const;
/**
 * Designs should prefer using multiples of 8 instead of 10
 */
const SPACING_10 = '10px' as const;
const SPACING_16 = '16px' as const;
const SPACING_24 = '24px' as const;
const SPACING_32 = '32px' as const;
const SPACING_48 = '48px' as const;

const SPACING = {
  XXS: SPACING_XXS,
  XS: SPACING_XS,
  SM: SPACING_SM,
  MD: SPACING_MD,
  LG: SPACING_LG,
  XL: SPACING_XL,
  XXL: SPACING_XXL,
  /**
   * Used occasionally on smaller screen sizes
   */
  S4: SPACING_4,
  S8: SPACING_8,
  /**
   * Designs should prefer using multiples of 8 instead of 10
   */
  S10: SPACING_10,
  S16: SPACING_16,
  S24: SPACING_24,
  S32: SPACING_32,
  S48: SPACING_48,
} as const;

export default SPACING;
